var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _rect, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _polygon, _path35, _path36, _path37, _path38, _path39, _polygon2, _polygon3, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSharjahChamber(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 76.3 29.6",
    style: {
      enableBackground: "new 0 0 76.3 29.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_2_);}\r\n\t.st2{fill:url(#SVGID_3_);}\r\n\t.st3{fill:url(#SVGID_4_);}\r\n\t.st4{fill:url(#SVGID_5_);}\r\n\t.st5{fill:url(#SVGID_6_);}\r\n\t.st6{fill:url(#SVGID_7_);}\r\n\t.st7{fill:url(#SVGID_8_);}\r\n\t.st8{fill:url(#SVGID_9_);}\r\n\t.st9{fill:url(#SVGID_10_);}\r\n\t.st10{fill:url(#SVGID_11_);}\r\n\t.st11{fill:url(#SVGID_12_);}\r\n\t.st12{fill:url(#SVGID_13_);}\r\n\t.st13{fill:url(#SVGID_14_);}\r\n\t.st14{fill:url(#SVGID_15_);}\r\n\t.st15{fill:url(#SVGID_16_);}\r\n\t.st16{fill:url(#SVGID_17_);}\r\n\t.st17{fill:url(#SVGID_18_);}\r\n\t.st18{fill:url(#SVGID_19_);}\r\n\t.st19{fill:url(#SVGID_20_);}\r\n\t.st20{fill:url(#SVGID_21_);}\r\n\t.st21{fill:url(#SVGID_22_);}\r\n\t.st22{fill:url(#SVGID_23_);}\r\n\t.st23{fill:url(#SVGID_24_);}\r\n\t.st24{fill:url(#SVGID_25_);}\r\n\t.st25{fill:url(#SVGID_26_);}\r\n\t.st26{fill:url(#SVGID_27_);}\r\n\t.st27{fill:url(#SVGID_28_);}\r\n\t.st28{fill:url(#SVGID_29_);}\r\n\t.st29{fill:url(#SVGID_30_);}\r\n\t.st30{fill:url(#SVGID_31_);}\r\n\t.st31{fill:url(#SVGID_32_);}\r\n\t.st32{fill:url(#SVGID_33_);}\r\n\t.st33{fill:url(#SVGID_34_);}\r\n\t.st34{fill:url(#SVGID_35_);}\r\n\t.st35{fill:url(#SVGID_36_);}\r\n\t.st36{fill:url(#SVGID_37_);}\r\n\t.st37{fill:url(#SVGID_38_);}\r\n\t.st38{fill:url(#SVGID_39_);}\r\n\t.st39{fill:url(#SVGID_40_);}\r\n\t.st40{fill:url(#SVGID_41_);}\r\n\t.st41{fill:url(#SVGID_42_);}\r\n\t.st42{fill:url(#SVGID_43_);}\r\n\t.st43{fill:url(#SVGID_44_);}\r\n\t.st44{fill:url(#SVGID_45_);}\r\n\t.st45{fill:url(#SVGID_46_);}\r\n\t.st46{fill:url(#SVGID_47_);}\r\n\t.st47{fill:url(#SVGID_48_);}\r\n\t.st48{fill:url(#SVGID_49_);}\r\n\t.st49{fill:url(#SVGID_50_);}\r\n\t.st50{fill:url(#SVGID_51_);}\r\n\t.st51{fill:url(#SVGID_52_);}\r\n\t.st52{fill:url(#SVGID_53_);}\r\n\t.st53{fill:url(#SVGID_54_);}\r\n\t.st54{fill:url(#SVGID_55_);}\r\n\t.st55{fill:url(#SVGID_56_);}\r\n\t.st56{fill:url(#SVGID_57_);}\r\n\t.st57{fill:url(#SVGID_58_);}\r\n\t.st58{fill:url(#SVGID_59_);}\r\n\t.st59{fill:url(#SVGID_60_);}\r\n\t.st60{fill:url(#SVGID_61_);}\r\n\t.st61{fill:url(#SVGID_62_);}\r\n\t.st62{fill:url(#SVGID_63_);}\r\n\t.st63{fill:url(#SVGID_64_);}\r\n\t.st64{fill:url(#SVGID_65_);}\r\n\t.st65{fill:url(#SVGID_66_);}\r\n\t.st66{fill:url(#SVGID_67_);}\r\n\t.st67{fill:url(#SVGID_68_);}\r\n\t.st68{fill:url(#SVGID_69_);}\r\n\t.st69{fill:url(#SVGID_70_);}\r\n\t.st70{fill:url(#SVGID_71_);}\r\n\t.st71{fill:url(#SVGID_72_);}\r\n\t.st72{fill:url(#SVGID_73_);}\r\n\t.st73{fill:url(#SVGID_74_);}\r\n\t.st74{fill:url(#SVGID_75_);}\r\n\t.st75{fill:url(#SVGID_76_);}\r\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.3377,
    y1: 6.4305,
    x2: 75.4587,
    y2: 6.4305
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M75.5,12.3v-0.1l-53.7-0.9c0-0.3,0.1-4.9-5.2-7.4C11.1,1.3,11,0.5,11,0.5s-0.2,0.7-5.6,3.3 c-5.5,2.6-5,7.3-5,7.3s0,0.8,0.2,1.1c0,0.1,0.1,0,0.1,0S-0.1,7.5,5.4,5C10.9,2.4,11,1.7,11,1.7s0.1,0.7,5.6,3.3 c4.9,2.3,4.9,6.4,4.9,7.2l0,0.1L75.5,12.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 8.4822,
    y1: 23.1763,
    x2: 9.3066,
    y2: 23.1763
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9.3,23.2c0,0.2-0.2,0.4-0.4,0.4c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4C9.1,22.8,9.3,22.9,9.3,23.2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.2341,
    y1: 24.8474,
    x2: 2.2502,
    y2: 24.8474
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M2.3,24H1.7v-0.1c0-0.1,0-0.2-0.1-0.3c-0.1-0.1-0.2-0.1-0.3-0.1c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0.1-0.1,0.1 c0,0,0,0.1-0.1,0.2c0,0.1,0,0.1,0,0.2c0,0.1,0,0.2,0,0.2c0,0.1,0,0.1,0,0.1c0,0,0.1,0.1,0.1,0.1c0,0,0.1,0.1,0.2,0.1l0.4,0.2 c0.1,0.1,0.2,0.1,0.3,0.2C2,24.8,2.1,24.9,2.1,25c0,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.2,0,0.4c0,0.2,0,0.3-0.1,0.5 c0,0.1-0.1,0.3-0.2,0.4c-0.1,0.1-0.2,0.2-0.3,0.2c-0.1,0.1-0.3,0.1-0.5,0.1c-0.1,0-0.3,0-0.4-0.1c-0.1-0.1-0.2-0.1-0.3-0.2 c-0.1-0.1-0.2-0.2-0.2-0.3c-0.1-0.1-0.1-0.2-0.1-0.4v-0.2h0.6v0.2c0,0.1,0,0.2,0.1,0.3c0.1,0.1,0.2,0.1,0.3,0.1c0.1,0,0.2,0,0.2,0 c0.1,0,0.1-0.1,0.1-0.1c0-0.1,0-0.1,0.1-0.2c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0-0.3c0-0.1,0-0.1-0.1-0.2c0,0-0.1-0.1-0.1-0.1 c0,0-0.1-0.1-0.2-0.1l-0.4-0.2c-0.3-0.1-0.4-0.2-0.5-0.4c-0.1-0.2-0.1-0.4-0.1-0.6c0-0.2,0-0.3,0.1-0.4c0-0.1,0.1-0.3,0.2-0.4 c0.1-0.1,0.2-0.2,0.3-0.2c0.1-0.1,0.3-0.1,0.4-0.1c0.1,0,0.3,0,0.4,0.1C1.8,22.9,1.9,23,2,23.1c0.1,0.1,0.2,0.2,0.2,0.3 c0,0.1,0.1,0.2,0.1,0.3L2.3,24L2.3,24z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 2.653,
    y1: 24.8485,
    x2: 4.4076,
    y2: 24.8485
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M2.7,22.8h0.6v1.5h0c0.1-0.1,0.1-0.2,0.2-0.2c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0.1,0.2,0.1 c0.1,0.1,0.1,0.1,0.1,0.2c0,0.1,0.1,0.2,0.1,0.3v2.2H3.8v-2c0-0.1,0-0.2-0.1-0.3c-0.1-0.1-0.1-0.1-0.2-0.1c-0.1,0-0.2,0-0.2,0.1 c0,0.1-0.1,0.2-0.1,0.3v2H2.7L2.7,22.8L2.7,22.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 4.7962,
    y1: 25.4362,
    x2: 6.5839,
    y2: 25.4362
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M6,26.6L6,26.6c-0.1,0.1-0.2,0.2-0.2,0.2c-0.1,0.1-0.2,0.1-0.3,0.1c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1-0.1-0.2-0.1 c-0.1-0.1-0.1-0.1-0.2-0.2c0-0.1-0.1-0.2-0.1-0.4c0-0.2,0-0.3,0-0.4c0-0.1,0.1-0.2,0.1-0.3c0.1-0.1,0.2-0.1,0.3-0.2 c0.1,0,0.3-0.1,0.5-0.1c0,0,0.1,0,0.1,0c0,0,0.1,0,0.2,0v-0.3c0-0.1,0-0.2-0.1-0.2c0-0.1-0.1-0.1-0.2-0.1c-0.1,0-0.1,0-0.2,0.1 c-0.1,0-0.1,0.1-0.1,0.2H4.8c0-0.3,0.1-0.5,0.3-0.6c0.1-0.1,0.2-0.1,0.3-0.2c0.1,0,0.2-0.1,0.4-0.1c0.1,0,0.2,0,0.3,0.1 c0.1,0,0.2,0.1,0.3,0.2c0.1,0.1,0.1,0.2,0.2,0.3c0,0.1,0.1,0.2,0.1,0.4v2H6L6,26.6L6,26.6z M6,25.6c-0.1,0-0.1,0-0.2,0 c-0.1,0-0.2,0-0.3,0.1c-0.1,0.1-0.1,0.2-0.1,0.3c0,0.1,0,0.2,0.1,0.3c0.1,0.1,0.1,0.1,0.2,0.1s0.2,0,0.2-0.1C6,26.2,6,26.2,6,26 V25.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 7.022,
    y1: 25.4185,
    x2: 8.3857,
    y2: 25.4185
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M7,24h0.6v0.3C7.7,24.2,7.8,24.1,8,24c0.1-0.1,0.3-0.1,0.4-0.1v0.6c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0 c-0.1,0-0.1,0.1-0.2,0.1c-0.1,0.1-0.1,0.1-0.1,0.2c0,0.1-0.1,0.2-0.1,0.3v1.7H7V24z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 9.5915,
    y1: 25.4362,
    x2: 11.3886,
    y2: 25.4362
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M10.8,26.6L10.8,26.6c-0.1,0.1-0.2,0.2-0.2,0.2c-0.1,0.1-0.2,0.1-0.3,0.1c-0.1,0-0.1,0-0.2,0 c-0.1,0-0.1-0.1-0.2-0.1c-0.1-0.1-0.1-0.1-0.2-0.2c0-0.1-0.1-0.2-0.1-0.4c0-0.2,0-0.3,0-0.4c0-0.1,0.1-0.2,0.1-0.3 c0.1-0.1,0.2-0.1,0.3-0.2c0.1,0,0.3-0.1,0.5-0.1c0,0,0.1,0,0.1,0c0,0,0.1,0,0.2,0v-0.3c0-0.1,0-0.2-0.1-0.2c0-0.1-0.1-0.1-0.2-0.1 c-0.1,0-0.1,0-0.2,0.1c-0.1,0-0.1,0.1-0.1,0.2H9.6c0-0.3,0.1-0.5,0.3-0.6c0.1-0.1,0.2-0.1,0.3-0.2c0.1,0,0.2-0.1,0.4-0.1 c0.1,0,0.2,0,0.3,0.1c0.1,0,0.2,0.1,0.3,0.2c0.1,0.1,0.1,0.2,0.2,0.3c0,0.1,0.1,0.2,0.1,0.4v2h-0.6L10.8,26.6L10.8,26.6z M10.8,25.6 c-0.1,0-0.1,0-0.2,0c-0.1,0-0.2,0-0.3,0.1c-0.1,0.1-0.1,0.2-0.1,0.3c0,0.1,0,0.2,0.1,0.3c0.1,0.1,0.1,0.1,0.2,0.1 c0.1,0,0.2,0,0.2-0.1c0.1-0.1,0.1-0.2,0.1-0.3L10.8,25.6L10.8,25.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 11.822,
    y1: 24.8485,
    x2: 13.5766,
    y2: 24.8485
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M11.8,22.8h0.6v1.5h0c0.1-0.1,0.1-0.2,0.2-0.2c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0,0.1,0,0.2,0 c0.1,0,0.1,0.1,0.2,0.1c0.1,0.1,0.1,0.1,0.1,0.2c0,0.1,0.1,0.2,0.1,0.3v2.2H13v-2c0-0.1,0-0.2-0.1-0.3c-0.1-0.1-0.1-0.1-0.2-0.1 c-0.1,0-0.2,0-0.2,0.1c0,0.1-0.1,0.2-0.1,0.3v2h-0.6V22.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.1288,
    y1: 24.8474,
    x2: 17.0271,
    y2: 24.8474
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M17,26c0,0.1,0,0.2-0.1,0.4s-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.2-0.3,0.2c-0.1,0.1-0.2,0.1-0.4,0.1 c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2-0.1-0.3-0.2c-0.1-0.1-0.2-0.2-0.2-0.3s-0.1-0.3-0.1-0.5v-2.3c0-0.1,0-0.3,0.1-0.4 c0-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.2-0.2,0.3-0.2c0.1,0,0.2-0.1,0.4-0.1c0.1,0,0.3,0,0.4,0.1c0.1,0,0.2,0.1,0.3,0.2 c0.1,0.1,0.2,0.2,0.2,0.3c0,0.1,0.1,0.3,0.1,0.4V24h-0.6v-0.2c0-0.1,0-0.2-0.1-0.3c-0.1-0.1-0.2-0.1-0.3-0.1c-0.1,0-0.2,0-0.3,0.1 c0,0.1-0.1,0.2-0.1,0.3v2.1c0,0.1,0,0.2,0.1,0.3c0.1,0.1,0.1,0.1,0.3,0.1c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1-0.1c0,0,0.1-0.1,0.1-0.1 c0-0.1,0-0.1,0-0.2v-0.2H17L17,26L17,26z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 17.4699,
    y1: 24.8485,
    x2: 19.2246,
    y2: 24.8485
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M17.5,22.8h0.6v1.5h0c0.1-0.1,0.1-0.2,0.2-0.2c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0,0.1,0,0.2,0 c0.1,0,0.1,0.1,0.2,0.1c0.1,0.1,0.1,0.1,0.1,0.2c0,0.1,0.1,0.2,0.1,0.3v2.2h-0.6v-2c0-0.1,0-0.2-0.1-0.3c0-0.1-0.1-0.1-0.2-0.1 c-0.1,0-0.2,0-0.2,0.1c0,0.1-0.1,0.2-0.1,0.3v2h-0.6L17.5,22.8L17.5,22.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 19.6108,
    y1: 25.4362,
    x2: 21.4032,
    y2: 25.4362
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M20.8,26.6L20.8,26.6c-0.1,0.1-0.2,0.2-0.2,0.2c-0.1,0.1-0.2,0.1-0.3,0.1c-0.1,0-0.1,0-0.2,0 c-0.1,0-0.1-0.1-0.2-0.1c-0.1-0.1-0.1-0.1-0.2-0.2c0-0.1-0.1-0.2-0.1-0.4c0-0.2,0-0.3,0-0.4c0-0.1,0.1-0.2,0.1-0.3 c0.1-0.1,0.2-0.1,0.3-0.2c0.1,0,0.3-0.1,0.5-0.1c0,0,0.1,0,0.1,0c0,0,0.1,0,0.2,0v-0.3c0-0.1,0-0.2-0.1-0.2c0-0.1-0.1-0.1-0.2-0.1 c-0.1,0-0.1,0-0.2,0.1c-0.1,0-0.1,0.1-0.1,0.2h-0.6c0-0.3,0.1-0.5,0.3-0.6c0.1-0.1,0.2-0.1,0.3-0.2c0.1,0,0.2-0.1,0.4-0.1 c0.1,0,0.2,0,0.3,0.1c0.1,0,0.2,0.1,0.3,0.2c0.1,0.1,0.1,0.2,0.2,0.3c0,0.1,0.1,0.2,0.1,0.4v2h-0.6L20.8,26.6L20.8,26.6z M20.8,25.6 c-0.1,0-0.1,0-0.2,0c-0.1,0-0.2,0-0.3,0.1c-0.1,0.1-0.1,0.2-0.1,0.3c0,0.1,0,0.2,0.1,0.3c0.1,0.1,0.1,0.1,0.2,0.1 c0.1,0,0.2,0,0.2-0.1c0.1-0.1,0.1-0.2,0.1-0.3L20.8,25.6L20.8,25.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 21.8318,
    y1: 25.4209,
    x2: 24.757,
    y2: 25.4209
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M21.8,24h0.6v0.3h0c0.1-0.1,0.1-0.2,0.2-0.2c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0,0.2,0,0.3,0.1 c0.1,0.1,0.2,0.1,0.2,0.2c0.1-0.1,0.2-0.1,0.2-0.2c0.1-0.1,0.2-0.1,0.4-0.1c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0.1,0.2,0.1 c0.1,0.1,0.1,0.1,0.2,0.2c0,0.1,0.1,0.2,0.1,0.3v2.2h-0.6v-2c0-0.1,0-0.2-0.1-0.3c-0.1-0.1-0.1-0.1-0.2-0.1c-0.1,0-0.2,0-0.2,0.1 c0,0.1-0.1,0.2-0.1,0.3v2H23v-2c0-0.1,0-0.2-0.1-0.3c-0.1-0.1-0.1-0.1-0.2-0.1c-0.1,0-0.2,0-0.2,0.1c0,0.1-0.1,0.2-0.1,0.3v2h-0.6 L21.8,24L21.8,24z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 25.2422,
    y1: 24.8615,
    x2: 26.9992,
    y2: 24.8615
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M25.2,22.8h0.6v1.4h0c0.1-0.1,0.1-0.2,0.2-0.2c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0,0.3,0,0.3,0.1 c0.1,0.1,0.1,0.1,0.2,0.2c0,0.1,0.1,0.1,0.1,0.2c0,0.1,0,0.3,0,0.5V26c0,0.2,0,0.3,0,0.4c0,0.1,0,0.2-0.1,0.2 c-0.1,0.2-0.3,0.3-0.5,0.3c-0.1,0-0.3,0-0.3-0.1c-0.1-0.1-0.1-0.1-0.2-0.2v0.3h-0.6L25.2,22.8L25.2,22.8z M26.4,24.9 c0-0.1,0-0.2-0.1-0.2c0-0.1-0.1-0.1-0.2-0.1c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.1-0.1,0.2V26c0,0.1,0,0.2,0.1,0.3 c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1c0-0.1,0.1-0.2,0.1-0.3L26.4,24.9L26.4,24.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 27.4256,
    y1: 25.4397,
    x2: 29.1779,
    y2: 25.4397
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M28,25.7v0.4c0,0.1,0,0.2,0.1,0.2c0,0,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1c0-0.1,0.1-0.1,0.1-0.2h0.6 c0,0.1,0,0.2-0.1,0.3c0,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1,0-0.2,0.1-0.4,0.1c-0.2,0-0.3,0-0.5-0.1 c-0.1-0.1-0.2-0.2-0.3-0.3c0-0.1-0.1-0.2-0.1-0.3c0-0.1,0-0.2,0-0.3v-1c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0.1-0.3 c0.1-0.1,0.2-0.2,0.3-0.3C28,24,28.1,24,28.3,24c0.1,0,0.3,0,0.4,0.1c0.1,0,0.2,0.1,0.3,0.2c0.1,0.1,0.1,0.2,0.2,0.3 c0,0.1,0.1,0.2,0.1,0.4v0.8L28,25.7L28,25.7z M28,25.2h0.6v-0.3c0-0.1,0-0.2-0.1-0.2c-0.1-0.1-0.1-0.1-0.2-0.1c-0.1,0-0.2,0-0.2,0.1 C28,24.7,28,24.8,28,24.9L28,25.2L28,25.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 29.6089,
    y1: 25.4185,
    x2: 30.9702,
    y2: 25.4185
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M29.6,24h0.6v0.3c0.1-0.1,0.2-0.2,0.4-0.3c0.1-0.1,0.3-0.1,0.4-0.1v0.6c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0 c-0.1,0-0.1,0.1-0.2,0.1c-0.1,0.1-0.1,0.1-0.1,0.2c0,0.1-0.1,0.2-0.1,0.3v1.7h-0.6V24z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 32.2279,
    y1: 25.435,
    x2: 33.9755,
    y2: 25.435
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M32.2,25c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0.1-0.3c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.3-0.1,0.5-0.1 c0.2,0,0.3,0,0.5,0.1c0.1,0.1,0.2,0.2,0.3,0.3c0,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.2,0,0.3v1c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2-0.1,0.3 c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.3,0.1-0.5,0.1c-0.2,0-0.3,0-0.5-0.1c-0.1-0.1-0.2-0.2-0.3-0.3c0-0.1-0.1-0.2-0.1-0.3 c0-0.1,0-0.2,0-0.3V25z M32.8,26c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1c0-0.1,0.1-0.1,0.1-0.2v-1.1 c0-0.1,0-0.2-0.1-0.2c-0.1-0.1-0.1-0.1-0.2-0.1c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.1-0.1,0.2V26z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 34.1946,
    y1: 24.8474,
    x2: 35.5064,
    y2: 24.8474
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M34.5,24.4h-0.3V24h0.3v-0.4c0-0.1,0-0.3,0.1-0.4c0-0.1,0.1-0.2,0.2-0.2c0.1-0.1,0.2-0.1,0.2-0.1 c0.1,0,0.2,0,0.3,0h0.3v0.6h-0.3c-0.1,0-0.2,0.1-0.2,0.2V24h0.4v0.5h-0.4v2.5h-0.6V24.4L34.5,24.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 36.7547,
    y1: 24.8474,
    x2: 38.6531,
    y2: 24.8474
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M38.7,26c0,0.1,0,0.2-0.1,0.4s-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.2-0.3,0.2c-0.1,0.1-0.2,0.1-0.4,0.1 c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2-0.1-0.3-0.2c-0.1-0.1-0.2-0.2-0.2-0.3c-0.1-0.1-0.1-0.3-0.1-0.5v-2.3c0-0.1,0-0.3,0.1-0.4 c0-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.2-0.2,0.3-0.2c0.1,0,0.2-0.1,0.4-0.1c0.1,0,0.3,0,0.4,0.1c0.1,0,0.2,0.1,0.3,0.2 c0.1,0.1,0.2,0.2,0.2,0.3c0,0.1,0.1,0.3,0.1,0.4V24h-0.6v-0.2c0-0.1,0-0.2-0.1-0.3c-0.1-0.1-0.2-0.1-0.3-0.1c-0.1,0-0.2,0-0.3,0.1 c0,0.1-0.1,0.2-0.1,0.3v2.1c0,0.1,0,0.2,0.1,0.3c0.1,0.1,0.1,0.1,0.3,0.1c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1-0.1c0,0,0.1-0.1,0.1-0.1 c0-0.1,0-0.1,0-0.2v-0.2h0.6V26z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 39.0464,
    y1: 25.435,
    x2: 40.794,
    y2: 25.435
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M39,25c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0.1-0.3c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.3-0.1,0.5-0.1 c0.2,0,0.3,0,0.5,0.1c0.1,0.1,0.2,0.2,0.3,0.3c0,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.2,0,0.3v1c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2-0.1,0.3 c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.3,0.1-0.5,0.1c-0.2,0-0.3,0-0.5-0.1c-0.1-0.1-0.2-0.2-0.3-0.3c0-0.1-0.1-0.2-0.1-0.3 c0-0.1,0-0.2,0-0.3V25z M39.6,26c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1c0.1-0.1,0.1-0.1,0.1-0.2v-1.1 c0-0.1,0-0.2-0.1-0.2c-0.1-0.1-0.1-0.1-0.2-0.1c-0.1,0-0.2,0-0.2,0.1c0,0.1-0.1,0.1-0.1,0.2V26z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 41.2179,
    y1: 25.4209,
    x2: 44.1455,
    y2: 25.4209
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M41.2,24h0.6v0.3h0c0.1-0.1,0.1-0.2,0.2-0.2c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0,0.2,0,0.3,0.1 c0.1,0.1,0.2,0.1,0.2,0.2c0.1-0.1,0.2-0.1,0.2-0.2c0.1-0.1,0.2-0.1,0.4-0.1c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0.1,0.2,0.1 c0.1,0.1,0.1,0.1,0.2,0.2c0,0.1,0.1,0.2,0.1,0.3v2.2h-0.6v-2c0-0.1,0-0.2-0.1-0.3c-0.1-0.1-0.1-0.1-0.2-0.1c-0.1,0-0.2,0-0.2,0.1 c0,0.1-0.1,0.2-0.1,0.3v2h-0.6v-2c0-0.1,0-0.2-0.1-0.3c-0.1-0.1-0.1-0.1-0.2-0.1c-0.1,0-0.2,0-0.2,0.1c0,0.1-0.1,0.2-0.1,0.3v2h-0.6 L41.2,24L41.2,24z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 44.6283,
    y1: 25.4209,
    x2: 47.5512,
    y2: 25.4209
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M44.6,24h0.6v0.3h0c0.1-0.1,0.1-0.2,0.2-0.2s0.2-0.1,0.3-0.1c0.1,0,0.2,0,0.3,0.1c0.1,0.1,0.2,0.1,0.2,0.2 c0.1-0.1,0.2-0.1,0.2-0.2c0.1-0.1,0.2-0.1,0.4-0.1c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0.1,0.2,0.1c0.1,0.1,0.1,0.1,0.1,0.2 c0,0.1,0.1,0.2,0.1,0.3v2.2H47v-2c0-0.1,0-0.2-0.1-0.3c-0.1-0.1-0.1-0.1-0.2-0.1c-0.1,0-0.2,0-0.2,0.1c0,0.1-0.1,0.2-0.1,0.3v2h-0.6 v-2c0-0.1,0-0.2-0.1-0.3c-0.1-0.1-0.1-0.1-0.2-0.1c-0.1,0-0.2,0-0.2,0.1c0,0.1-0.1,0.2-0.1,0.3v2h-0.6V24z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 47.9822,
    y1: 25.4397,
    x2: 49.7345,
    y2: 25.4397
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M48.6,25.7v0.4c0,0.1,0,0.2,0.1,0.2c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1c0-0.1,0.1-0.1,0.1-0.2h0.6 c0,0.1,0,0.2-0.1,0.3c0,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1,0-0.2,0.1-0.4,0.1c-0.2,0-0.3,0-0.5-0.1 c-0.1-0.1-0.2-0.2-0.3-0.3c0-0.1-0.1-0.2-0.1-0.3c0-0.1,0-0.2,0-0.3v-1c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0.1-0.3 c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.3-0.1,0.5-0.1c0.1,0,0.3,0,0.4,0.1c0.1,0,0.2,0.1,0.3,0.2s0.1,0.2,0.2,0.3 c0,0.1,0.1,0.2,0.1,0.4v0.8L48.6,25.7L48.6,25.7z M48.6,25.2h0.6v-0.3c0-0.1,0-0.2-0.1-0.2c0-0.1-0.1-0.1-0.2-0.1 c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.1-0.1,0.2L48.6,25.2L48.6,25.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 50.1656,
    y1: 25.4185,
    x2: 51.5292,
    y2: 25.4185
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M50.2,24h0.6v0.3c0.1-0.1,0.2-0.2,0.4-0.3c0.1-0.1,0.3-0.1,0.4-0.1v0.6c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0 c-0.1,0-0.1,0.1-0.2,0.1c-0.1,0.1-0.1,0.1-0.1,0.2c0,0.1-0.1,0.2-0.1,0.3v1.7h-0.6V24z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 51.7294,
    y1: 25.4373,
    x2: 53.4794,
    y2: 25.4373
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M52.3,26.1c0,0.1,0,0.2,0.1,0.2c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1c0-0.1,0.1-0.1,0.1-0.2h0.6 c0,0.1,0,0.2-0.1,0.3c0,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1,0-0.2,0.1-0.4,0.1c-0.2,0-0.3,0-0.5-0.1 c-0.1-0.1-0.2-0.2-0.3-0.3c0-0.1-0.1-0.2-0.1-0.3c0-0.1,0-0.2,0-0.3v-1c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0.1-0.3 c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.3-0.1,0.5-0.1c0.1,0,0.3,0,0.4,0.1c0.1,0,0.2,0.1,0.3,0.2c0.1,0.1,0.1,0.2,0.2,0.3 c0,0.1,0.1,0.2,0.1,0.4h-0.6c0-0.1,0-0.2-0.1-0.3c-0.1-0.1-0.1-0.1-0.2-0.1c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.1-0.1,0.2 L52.3,26.1L52.3,26.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 53.7785,
    y1: 25.4397,
    x2: 55.5237,
    y2: 25.4397
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M54.4,25.7v0.4c0,0.1,0,0.2,0.1,0.2c0,0,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1c0-0.1,0.1-0.1,0.1-0.2h0.6 c0,0.1,0,0.2-0.1,0.3c0,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1,0-0.2,0.1-0.4,0.1c-0.2,0-0.3,0-0.5-0.1 c-0.1-0.1-0.2-0.2-0.3-0.3c0-0.1-0.1-0.2-0.1-0.3c0-0.1,0-0.2,0-0.3v-1c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0.1-0.3 c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.3-0.1,0.5-0.1c0.1,0,0.3,0,0.4,0.1c0.1,0,0.2,0.1,0.3,0.2c0.1,0.1,0.1,0.2,0.2,0.3 c0,0.1,0.1,0.2,0.1,0.4v0.8L54.4,25.7L54.4,25.7z M54.4,25.2h0.6v-0.3c0-0.1,0-0.2-0.1-0.2c-0.1-0.1-0.1-0.1-0.2-0.1 c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.1-0.1,0.2L54.4,25.2L54.4,25.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 56.9887,
    y1: 25.0487,
    x2: 59.4005,
    y2: 25.0487
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M58.6,26.6c-0.1,0.1-0.2,0.2-0.4,0.3c-0.1,0.1-0.3,0.1-0.4,0.1c-0.1,0-0.2,0-0.3-0.1c-0.1,0-0.2-0.1-0.3-0.2 c-0.1-0.1-0.1-0.2-0.2-0.3c0-0.1-0.1-0.2-0.1-0.4c0-0.2,0.1-0.4,0.2-0.6c0.1-0.2,0.2-0.3,0.4-0.5c-0.1-0.1-0.2-0.3-0.3-0.4 c-0.1-0.2-0.1-0.3-0.1-0.5c0-0.1,0-0.2,0.1-0.3c0-0.1,0.1-0.2,0.1-0.3c0.1-0.1,0.1-0.1,0.2-0.2c0.1,0,0.2-0.1,0.3-0.1 c0.1,0,0.2,0,0.3,0.1c0.1,0,0.2,0.1,0.2,0.2c0.1,0.1,0.1,0.1,0.1,0.2c0,0.1,0.1,0.2,0.1,0.3c0,0.2-0.1,0.4-0.2,0.6 c-0.1,0.2-0.3,0.3-0.4,0.5c0.1,0.1,0.2,0.2,0.2,0.4c0.1,0.2,0.2,0.3,0.3,0.5l0.3-0.4l0.4,0.3L59,26.2l0.4,0.7h-0.6L58.6,26.6z  M57.5,26c0,0.1,0,0.3,0.1,0.4c0.1,0.1,0.2,0.2,0.3,0.2c0.1,0,0.2,0,0.3-0.1c0.1-0.1,0.1-0.1,0.2-0.2l-0.6-0.9 c-0.1,0.1-0.2,0.2-0.2,0.3C57.5,25.7,57.5,25.8,57.5,26 M57.7,24c0,0.1,0,0.2,0.1,0.3c0,0.1,0.1,0.2,0.2,0.3c0,0,0.1-0.1,0.1-0.1 c0,0,0.1-0.1,0.1-0.1c0-0.1,0.1-0.1,0.1-0.2c0-0.1,0-0.1,0-0.2s0-0.1-0.1-0.2c-0.1-0.1-0.1-0.1-0.2-0.1c-0.1,0-0.2,0-0.2,0.1 C57.7,23.8,57.7,23.9,57.7,24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 60.9126,
    y1: 24.8474,
    x2: 61.499,
    y2: 24.8474
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 60.9,
    y: 22.8,
    className: "st26",
    width: 0.6,
    height: 4.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 62.0313,
    y1: 25.4197,
    x2: 63.7884,
    y2: 25.4197
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M62,24h0.6v0.3h0c0.1-0.1,0.1-0.2,0.2-0.2s0.2-0.1,0.3-0.1c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0.1,0.2,0.1 c0.1,0.1,0.1,0.1,0.1,0.2c0,0.1,0.1,0.2,0.1,0.3v2.2h-0.6v-2c0-0.1,0-0.2-0.1-0.3c-0.1-0.1-0.1-0.1-0.2-0.1c-0.1,0-0.2,0-0.2,0.1 c0,0.1-0.1,0.2-0.1,0.3v2H62L62,24L62,24z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 64.2688,
    y1: 24.8638,
    x2: 66.0258,
    y2: 24.8638
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M65.4,26.6c0,0-0.1,0.1-0.1,0.1c0,0-0.1,0.1-0.1,0.1c0,0-0.1,0-0.1,0.1c-0.1,0-0.1,0-0.2,0 c-0.2,0-0.4-0.1-0.5-0.3c0-0.1-0.1-0.1-0.1-0.2c0-0.1,0-0.2,0-0.4v-1.1c0-0.2,0-0.4,0-0.5c0-0.1,0-0.2,0.1-0.2 c0.1-0.1,0.1-0.1,0.2-0.2c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0,0.2,0,0.3,0.1c0.1,0.1,0.2,0.1,0.2,0.2h0v-1.4H66v4.1h-0.6L65.4,26.6 L65.4,26.6z M64.9,25.9c0,0.1,0,0.2,0.1,0.3c0,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1c0.1-0.1,0.1-0.2,0.1-0.3v-1.1 c0-0.1,0-0.2-0.1-0.2c-0.1-0.1-0.1-0.1-0.2-0.1c-0.1,0-0.2,0-0.2,0.1c0,0.1-0.1,0.1-0.1,0.2L64.9,25.9L64.9,25.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 66.5134,
    y1: 25.4527,
    x2: 68.2681,
    y2: 25.4527
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M68.3,26.9h-0.6v-0.3h0c-0.1,0.1-0.1,0.2-0.2,0.2s-0.2,0.1-0.3,0.1c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1-0.1-0.2-0.1 c-0.1-0.1-0.1-0.1-0.1-0.2c0-0.1-0.1-0.2-0.1-0.3V24h0.6v2c0,0.1,0,0.2,0.1,0.3c0,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1 c0-0.1,0.1-0.2,0.1-0.3v-2h0.6L68.3,26.9L68.3,26.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 68.6473,
    y1: 25.4374,
    x2: 70.3949,
    y2: 25.4374
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M69.8,24.8c0-0.1,0-0.2-0.1-0.2c-0.1-0.1-0.1-0.1-0.2-0.1c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.1-0.1,0.2 c0,0.1,0,0.1,0,0.2c0,0.1,0.1,0.1,0.2,0.1l0.3,0.1c0.2,0.1,0.4,0.2,0.4,0.3c0.1,0.1,0.1,0.3,0.1,0.5c0,0.1,0,0.2-0.1,0.3 c0,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1,0-0.2,0.1-0.4,0.1c-0.1,0-0.2,0-0.3-0.1c-0.1,0-0.2-0.1-0.3-0.2 c-0.1-0.1-0.1-0.2-0.2-0.3c-0.1-0.1-0.1-0.2-0.1-0.4h0.6c0,0.1,0,0.2,0.1,0.2c0,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1 c0.1-0.1,0.1-0.1,0.1-0.2c0-0.1,0-0.2-0.1-0.2c0-0.1-0.1-0.1-0.2-0.1l-0.3-0.1c-0.2-0.1-0.3-0.2-0.4-0.3c-0.1-0.1-0.2-0.3-0.2-0.5 c0-0.1,0-0.2,0.1-0.3c0-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.2-0.1,0.3-0.2c0.1,0,0.2-0.1,0.3-0.1c0.1,0,0.2,0,0.3,0.1 c0.1,0,0.2,0.1,0.3,0.2c0.1,0.1,0.1,0.2,0.2,0.3c0,0.1,0.1,0.2,0.1,0.3L69.8,24.8L69.8,24.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 70.482,
    y1: 24.9922,
    x2: 71.7232,
    y2: 24.9922
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M70.8,23.1h0.6V24h0.4v0.5h-0.4v1.6c0,0.1,0,0.1,0,0.2c0,0,0,0.1,0.1,0.1c0,0,0.1,0,0.1,0c0,0,0.1,0,0.2,0v0.6 h-0.2c-0.1,0-0.2,0-0.3-0.1c-0.1,0-0.2-0.1-0.2-0.2c-0.1-0.1-0.1-0.1-0.1-0.2c0-0.1,0-0.2,0-0.2v-1.8h-0.3V24h0.3L70.8,23.1 L70.8,23.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 71.947,
    y1: 25.4185,
    x2: 73.3107,
    y2: 25.4185
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M71.9,24h0.6v0.3c0.1-0.1,0.2-0.2,0.4-0.3c0.1-0.1,0.3-0.1,0.4-0.1v0.6c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0 c-0.1,0-0.1,0.1-0.2,0.1c-0.1,0.1-0.1,0.1-0.1,0.2c0,0.1-0.1,0.2-0.1,0.3v1.7h-0.6L71.9,24L71.9,24z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 7.5731,
    y1: 26.5137,
    x2: 9.2053,
    y2: 26.5137
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M8.6,27.4c0,0.7-0.3,1.3-1.1,1.7c1.5-0.2,1.6-1.1,1.6-1.9V24H8.6L8.6,27.4L8.6,27.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 72.5664,
    y1: 26.5102,
    x2: 75.4563,
    y2: 26.5102
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M74,27.4c-0.2,0.7-0.7,1.3-1.5,1.7c1.6-0.2,1.9-1.1,2.1-1.9l0.8-3.2l-0.6,0L74,27.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 73.4025,
    y1: 25.369,
    x2: 74.4435,
    y2: 25.369
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st35",
    points: "74.4,25.8 74,24 73.4,24 74.2,26.8 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.3401,
    y1: 18.2632,
    x2: 7.1162,
    y2: 18.2632
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M7.1,16.5c-1.6,0.2-1.8,1.1-1.8,2v1H4.5H4.4H3.3H3.2H2.1v-2.9c-1.6,0.2-1.7,1.1-1.7,2v1.6H2h0h1.1h0.1h1.1h0.1 h2.6V16.5z M1.5,19.4H1v-1.1c0-0.5,0.2-1,0.5-1.4V19.4z M6.5,19.4H6v-1.1c0-0.5,0.2-1,0.5-1.3V19.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 6.9513,
    y1: 19.4903,
    x2: 8.6918,
    y2: 19.4903
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M8.1,20.7c0,0.8-0.4,1.4-1.1,1.8c1.6-0.2,1.7-1.2,1.7-2v-4l-0.6,0.4L8.1,20.7L8.1,20.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 16.768,
    y1: 15.5841,
    x2: 17.5924,
    y2: 15.5841
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M17.2,16c0.2,0,0.4-0.2,0.4-0.4c0-0.2-0.2-0.4-0.4-0.4c-0.2,0-0.4,0.2-0.4,0.4C16.8,15.8,17,16,17.2,16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: 18.021,
    y1: 15.5841,
    x2: 18.8336,
    y2: 15.5841
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M18.4,16c0.2,0,0.4-0.2,0.4-0.4c0-0.2-0.2-0.4-0.4-0.4c-0.2,0-0.4,0.2-0.4,0.4C18,15.8,18.2,16,18.4,16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.5127,
    y1: 15.5841,
    x2: 16.3252,
    y2: 15.5841
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M15.9,16c0.2,0,0.4-0.2,0.4-0.4c0-0.2-0.2-0.4-0.4-0.4c-0.2,0-0.4,0.2-0.4,0.4C15.5,15.8,15.7,16,15.9,16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: 9.3537,
    y1: 17.042,
    x2: 20.315,
    y2: 17.042
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "19.7,19.4 18.7,19.4 18.7,16.5 18.1,16.9 18.1,19.4 17.5,19.4 17.5,16.5 16.9,16.9 16.9,19.4  16.2,19.4 16.2,16.5 15.6,16.9 15.6,19.4 14.7,19.4 14.6,19.4 13.6,19.4 13.5,19.4 12.4,19.4 12.3,19.4 11.2,19.4 11.1,19.4  10,19.4 10,14 9.4,14.4 9.4,20.1 10,20.1 10,20.1 11.1,20.1 11.2,20.1 12.3,20.1 12.4,20.1 13.5,20.1 13.6,20.1 14.6,20.1  14.7,20.1 18.7,20.1 18.7,20.1 20.3,20.1 20.3,14 19.7,14.4 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: 20.9839,
    y1: 17.042,
    x2: 21.6151,
    y2: 17.042
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st42",
    points: "21,20.1 21.6,20.1 21.6,14 21,14.4 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: 23.4899,
    y1: 18.9227,
    x2: 30.6428,
    y2: 18.9227
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M29.1,18.3c0-0.8,0.4-1.4,1.1-1.8c-1.6,0.2-1.8,1.2-1.8,2v0.9h-0.9h-0.1h-1.1h-0.1h-1.1v-2.9 c-1.6,0.2-1.7,1.1-1.7,2v1.6h1.7h0h1.1h0.1h1.1h0.1h0.9v1.3l0.6-0.4v-0.9h1.2l0.3-0.7h-1.5V18.3z M24.6,19.4h-0.5v-1.1 c0-0.5,0.2-1,0.5-1.4V19.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: 36.2319,
    y1: 15.5841,
    x2: 37.0491,
    y2: 15.5841
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M36.6,16c0.2,0,0.4-0.2,0.4-0.4c0-0.2-0.2-0.4-0.4-0.4c-0.2,0-0.4,0.2-0.4,0.4C36.2,15.8,36.4,16,36.6,16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: 31.2316,
    y1: 17.685,
    x2: 40.012,
    y2: 17.685
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M38.5,15.6v-0.4l-0.6,0.4v3.8H37v-2.9l-0.6,0.4v2.5h-0.9h-0.1h-1.1h-0.1h-1.1H33h-1.1V14l-0.6,0.4v5.7h0.6h0 H33h0.1h1.1h0.1h1.1h0.1h1.4H37h0.9v1.3l0.6-0.4v-0.9H40v-2.6C40,16.6,39.6,15.8,38.5,15.6 M39.4,19.4h-0.9v-3.6 c0.4,0.2,0.9,0.7,0.9,1.5V19.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_47_",
    gradientUnits: "userSpaceOnUse",
    x1: 40.6762,
    y1: 19.4903,
    x2: 42.4309,
    y2: 19.4903
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M40.7,18.4v1.6h0h1.1v0.6c0,0.8-0.3,1.4-1.1,1.8c1.6-0.2,1.8-1.4,1.8-2.2v-3.8C40.8,16.7,40.7,17.6,40.7,18.4  M41.3,18.3c0-0.5,0.1-1,0.5-1.4v2.5h-0.5V18.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: 44.301,
    y1: 18.2632,
    x2: 46.0415,
    y2: 18.2632
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M46,16.5c-1.6,0.2-1.7,1.1-1.7,2v1.6H46V16.5z M45.4,19.4h-0.5v-1.1c0-0.5,0.2-1,0.5-1.4V19.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_49_",
    gradientUnits: "userSpaceOnUse",
    x1: 45.8719,
    y1: 19.4903,
    x2: 47.6148,
    y2: 19.4903
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M47,20.7c0,0.8-0.4,1.4-1.1,1.8c1.6-0.2,1.7-1.2,1.7-2v-4L47,16.9V20.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_50_",
    gradientUnits: "userSpaceOnUse",
    x1: 48.279,
    y1: 17.042,
    x2: 57.4574,
    y2: 17.042
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M56.8,19.4h-0.9h-0.1h-1.1v-2.2c0-0.8-0.1-1.8-1.8-2c0.8,0.4,1.1,1.1,1.1,1.8v2.4h-1.6h-0.1h-1.1h-0.1h-1.1 h-0.1h-1.1V14l-0.6,0.4v5.7h0.6h0h1.1h0.1h1.1h0.1h1.1h0.1h2.2h0h1.1h0.1h1.5v-3.6l-0.6,0.4L56.8,19.4L56.8,19.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_51_",
    gradientUnits: "userSpaceOnUse",
    x1: 59.3416,
    y1: 18.2632,
    x2: 68.473,
    y2: 18.2632
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M68.5,16.5c-1.6,0.2-1.7,1.1-1.7,2v1h-0.9h-0.1h-1.1h-0.1h-1.1h-0.1h-1.1h-0.1h-1.1v-2.9 c-1.6,0.2-1.7,1.1-1.7,2v1.6H61h0h1.1h0.1h1.1h0.1h1.1h0.1h1.1h0.1h2.6L68.5,16.5L68.5,16.5z M60.5,19.4H60v-1.1 c0-0.5,0.2-1,0.5-1.4V19.4z M67.8,19.4h-0.5v-1.1c0-0.5,0.2-1,0.5-1.3V19.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_52_",
    gradientUnits: "userSpaceOnUse",
    x1: 67.7475,
    y1: 15.5841,
    x2: 68.5601,
    y2: 15.5841
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M68.2,16c0.2,0,0.4-0.2,0.4-0.4c0-0.2-0.2-0.4-0.4-0.4c-0.2,0-0.4,0.2-0.4,0.4C67.7,15.8,67.9,16,68.2,16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_53_",
    gradientUnits: "userSpaceOnUse",
    x1: 68.2987,
    y1: 19.4868,
    x2: 75.4516,
    y2: 19.4868
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M74,19.4v-1.1c0-0.8,0.3-1.4,1.1-1.8c-1.6,0.2-1.8,1.2-1.8,2v0.9h-0.9h-0.1h-1.1h-0.1H70v-2.9l-0.6,0.4v3.8 c0,0.8-0.4,1.4-1.1,1.8c1.6-0.2,1.7-1.2,1.7-2v-0.4h1.1h0.1h1.1h0.1h0.9v1.3L74,21v-0.9h1.2l0.3-0.7L74,19.4L74,19.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_54_",
    gradientUnits: "userSpaceOnUse",
    x1: 6.949,
    y1: 22.5121,
    x2: 7.0479,
    y2: 22.5121
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M6.9,22.5C7,22.5,7,22.5,6.9,22.5L6.9,22.5C7,22.5,7,22.5,6.9,22.5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_55_",
    gradientUnits: "userSpaceOnUse",
    x1: 6.9749,
    y1: 22.2613,
    x2: 8.1925,
    y2: 22.2613
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M7.6,22c-0.2,0.2-0.4,0.3-0.6,0.5H7c0.5-0.1,0.9-0.3,1.1-0.5H7.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_56_",
    gradientUnits: "userSpaceOnUse",
    x1: 40.6762,
    y1: 22.5121,
    x2: 40.7751,
    y2: 22.5121
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M40.7,22.5C40.7,22.5,40.7,22.5,40.7,22.5L40.7,22.5C40.7,22.5,40.7,22.5,40.7,22.5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_57_",
    gradientUnits: "userSpaceOnUse",
    x1: 40.7045,
    y1: 22.2613,
    x2: 41.8656,
    y2: 22.2613
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M41.3,22c-0.2,0.2-0.4,0.3-0.6,0.5h0.1c0.5-0.1,0.9-0.3,1.1-0.5H41.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_58_",
    gradientUnits: "userSpaceOnUse",
    x1: 45.8719,
    y1: 22.5121,
    x2: 45.9732,
    y2: 22.5121
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M45.9,22.5c0,0,0.1,0,0.1,0L45.9,22.5C45.9,22.5,45.9,22.5,45.9,22.5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_59_",
    gradientUnits: "userSpaceOnUse",
    x1: 45.9002,
    y1: 22.2613,
    x2: 47.1179,
    y2: 22.2613
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M46.5,22c-0.2,0.2-0.4,0.3-0.6,0.5H46c0.5-0.1,0.9-0.3,1.1-0.5H46.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_60_",
    gradientUnits: "userSpaceOnUse",
    x1: 68.2987,
    y1: 22.5121,
    x2: 68.4,
    y2: 22.5121
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M68.3,22.5c0,0,0.1,0,0.1,0L68.3,22.5C68.3,22.5,68.3,22.5,68.3,22.5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_61_",
    gradientUnits: "userSpaceOnUse",
    x1: 68.3269,
    y1: 22.2613,
    x2: 69.5493,
    y2: 22.2613
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M68.9,22c-0.2,0.2-0.4,0.3-0.6,0.5h0.1c0.5-0.1,0.9-0.3,1.1-0.5H68.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_62_",
    gradientUnits: "userSpaceOnUse",
    x1: 73.9183,
    y1: 15.5841,
    x2: 74.7403,
    y2: 15.5841
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M74.3,16c0.2,0,0.4-0.2,0.4-0.4c0-0.2-0.2-0.4-0.4-0.4c-0.2,0-0.4,0.2-0.4,0.4C73.9,15.8,74.1,16,74.3,16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_63_",
    gradientUnits: "userSpaceOnUse",
    x1: 60.2201,
    y1: 15.5547,
    x2: 61.0445,
    y2: 15.5547
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st62",
    d: "M60.6,16c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4C61,15.8,60.9,16,60.6,16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_64_",
    gradientUnits: "userSpaceOnUse",
    x1: 59.3322,
    y1: 15.557,
    x2: 60.1589,
    y2: 15.557
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "M59.7,16c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4S60,16,59.7,16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_65_",
    gradientUnits: "userSpaceOnUse",
    x1: 56.7202,
    y1: 15.5547,
    x2: 57.5446,
    y2: 15.5547
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st64",
    d: "M57.1,16c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4C57.5,15.8,57.4,16,57.1,16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_66_",
    gradientUnits: "userSpaceOnUse",
    x1: 55.8323,
    y1: 15.557,
    x2: 56.6614,
    y2: 15.557
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M56.2,16c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4C56.7,15.8,56.5,16,56.2,16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_67_",
    gradientUnits: "userSpaceOnUse",
    x1: 45.236,
    y1: 15.5547,
    x2: 46.0603,
    y2: 15.5547
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M45.6,16c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4C46.1,15.8,45.9,16,45.6,16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_68_",
    gradientUnits: "userSpaceOnUse",
    x1: 44.3481,
    y1: 15.557,
    x2: 45.1724,
    y2: 15.557
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M44.8,16c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4S45,16,44.8,16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_69_",
    gradientUnits: "userSpaceOnUse",
    x1: 24.4579,
    y1: 15.5547,
    x2: 25.2846,
    y2: 15.5547
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st68",
    d: "M24.9,16c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4C25.3,15.8,25.1,16,24.9,16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_70_",
    gradientUnits: "userSpaceOnUse",
    x1: 23.57,
    y1: 15.557,
    x2: 24.399,
    y2: 15.557
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M24,16c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4C24.4,15.8,24.2,16,24,16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_71_",
    gradientUnits: "userSpaceOnUse",
    x1: 6.3884,
    y1: 15.5547,
    x2: 7.2151,
    y2: 15.5547
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st70",
    d: "M6.8,16c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4C7.2,15.8,7,16,6.8,16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_72_",
    gradientUnits: "userSpaceOnUse",
    x1: 5.5028,
    y1: 15.557,
    x2: 6.3295,
    y2: 15.557
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M5.9,16c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4S6.1,16,5.9,16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_73_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.2751,
    y1: 15.5547,
    x2: 2.1042,
    y2: 15.5547
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st72",
    d: "M1.7,16c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4C2.1,15.8,1.9,16,1.7,16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_74_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.3896,
    y1: 15.557,
    x2: 1.2163,
    y2: 15.557
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st73",
    d: "M0.8,16c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4S1,16,0.8,16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_75_",
    gradientUnits: "userSpaceOnUse",
    x1: 53.0955,
    y1: 20.9565,
    x2: 53.8963,
    y2: 20.9565
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st74",
    d: "M53.5,20.5c-0.2,0-0.4,0.2-0.4,0.4s0.2,0.4,0.4,0.4c0.2,0,0.4-0.2,0.4-0.4C53.9,20.7,53.7,20.5,53.5,20.5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharjahChamber);
export default __webpack_public_path__ + "static/media/sharjah_chamber.37afaa24517d9028d3a01b6059edbd8d.svg";
export { ForwardRef as ReactComponent };